import { safeDefine } from "../../registration/safe-define.js";
import { TimeSliderElement } from "../../ui/time-slider/element.js";
//#region src/define/ui/time-slider.ts
safeDefine(TimeSliderElement);
//#endregion
